module.exports = __webpack_public_path__ + "static/media/fedpa-bumper_selected.5c0e77ab.svg";